import React from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';

const StyledRoot = styled(Container)`
  width: 100%;
  max-width: 401px;
  min-width: 401px;
  @media (max-width: 1024px) {
    min-width: 0;
    max-width: none;
  }
`;

const StyledContainer = styled(Container)`
  padding: 25px;
  border-radius: 11px;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.02);
  border: solid 1px #ececec;
  background-color: #ffffff;
  margin-bottom: 19px;
  h2 {
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 14px;
  }
  p {
    color: #757575;
    font-size: 16px;
    margin-top: 0;
    &:last-child:not(:first-child) {
      margin-bottom: 0;
    }
  }
  ul {
    padding: 0;
  }
  ul li {
    margin-bottom: 10px;
    display: flex;
  }

  ul li p {
    margin: 0;
  }

  ul li i {
    color: #00a699;
    position: relative;
    left: -6px;
  }
  a,
  button {
    color: ${props => props.theme.primary.normal};
    display: flex;
    font-weight: 600;
    padding: 0;
    margin: 0;
    outline: none;
    cursor: pointer;
    i {
      position: relative;
      top: -1px;
    }
  }
`;

const SideBar = ({ items }) => {
  return (
    <StyledRoot className="UserManagement__Sidebar">
      {items.map(({ icon, iconWidth, title, children }, key) => (
        <StyledContainer key={key.toString()}>
          <img src={icon} alt={title} width={iconWidth} />
          <h2>{title}</h2>
          {children}
        </StyledContainer>
      ))}
    </StyledRoot>
  );
};

export default SideBar;
